<template>
  <div class="order-binding">
    <el-form
      ref="bindingForm"
      :model="bindingForm"
      :rules="bindingRules"
      label-width="60px"
      size="small"
    >
      <!-- <el-form-item label="企业ID" prop="corpId">
        <el-input
          v-model="bindingForm.corpId"
          placeholder="请输入企业ID"
          :disabled="loading"
        />
      </el-form-item> -->

      <el-form-item label="生产号码" prop="prodPhone">
        <el-input
          v-model="bindingForm.prodPhone"
          placeholder="请输入生产号码"
          :disabled="loading"
        />
      </el-form-item>

      <el-form-item label="收件号码" prop="receiverPhone">
        <el-input
          v-model="bindingForm.receiverPhone"
          placeholder="请输入收件号码"
          :disabled="loading"
        />
      </el-form-item>

      <!-- <el-form-item label="服务端ID" prop="serUserId">
        <el-input
          v-model="bindingForm.serUserId"
          placeholder="请输入服务端用户ID"
          :disabled="loading"
        />
      </el-form-item>

      <el-form-item label="客户ID" prop="externalUserId">
        <el-input
          v-model="bindingForm.externalUserId"
          placeholder="请输入客户ID"
          :disabled="loading"
        />
      </el-form-item> -->

      <el-form-item>
        <el-button
          type="primary"
          @click="handleSubmit"
          :loading="loading"
          size="small"
        >
          {{ loading ? "绑定中..." : "确认绑定" }}
        </el-button>
        <el-button @click="handleReset" :disabled="loading" size="small">
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { linkOrder } from "@/api/wechat";

export default {
  name: "OrderBinding",
  props: {
    // 可以从父组件传入默认值
    defaultCorpId: {
      type: String,
      default: "",
    },
    defaultSerUserId: {
      type: String,
      default: "",
    },
    defaultExternalUserId: {
      type: String,
      default: "",
    },
  },
  mounted() {
    // 组件挂载时自动填充默认值
    this.initFormData();
  },
  data() {
    return {
      loading: false,
      bindingForm: {
        corpId: "",
        prodPhone: "",
        receiverPhone: "",
        serUserId: "",
        externalUserId: "",
      },
      bindingRules: {
        // corpId: [{ required: true, message: "请输入企业ID", trigger: "blur" }],
        // prodPhone: [
        //   { required: true, message: "请输入生产号码", trigger: "blur" },
        //   {
        //     pattern: /^1[3-9]\d{9}$/,
        //     message: "请输入正确的手机号码",
        //     trigger: "blur",
        //   },
        // ],
        // receiverPhone: [
        //   { required: true, message: "请输入收件号码", trigger: "blur" },
        //   {
        //     pattern: /^1[3-9]\d{9}$/,
        //     message: "请输入正确的手机号码",
        //     trigger: "blur",
        //   },
        // ],
        // serUserId: [
        //   { required: true, message: "请输入服务端用户ID", trigger: "blur" },
        // ],
        // externalUserId: [
        //   { required: true, message: "请输入客户ID", trigger: "blur" },
        // ],
      },
    };
  },
  methods: {
    // 提交绑定
    handleSubmit() {
      this.$refs.bindingForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.loading = true;
        try {
          // 获取 customerNo（从本地存储的 customerNo）
          const customerNo = localStorage.getItem("wechat_customerNo") || "";

          const payload = {
            prodPhone: this.bindingForm.prodPhone,
            receiverPhone: this.bindingForm.receiverPhone,
            corpId: this.bindingForm.corpId,
            serUserId: this.bindingForm.serUserId,
            customerNo: customerNo,
          };

          const response = await linkOrder(payload);

          if (response.code === 200 || response.success) {
            this.$message.success("订单绑定成功");
            this.handleReset();
            this.$emit("binding-success", response);
          } else {
            this.$message.error(response.message || "绑定失败");
          }
        } catch (error) {
          console.error("订单绑定失败:", error);
          this.$message.error(`绑定失败: ${error.message}`);
        } finally {
          this.loading = false;
        }
      });
    },

    // 重置表单
    handleReset() {
      this.$refs.bindingForm.resetFields();
      this.bindingForm = {
        // corpId: "",
        prodPhone: "",
        receiverPhone: "",
        // serUserId: "",
        // externalUserId: "",
      };
    },

    // 设置表单数据
    setFormData(data) {
      Object.keys(data).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.bindingForm, key)) {
          this.bindingForm[key] = data[key];
        }
      });
    },

    // 初始化表单数据
    initFormData() {
      if (this.defaultCorpId) {
        this.bindingForm.corpId = this.defaultCorpId;
      }
      if (this.defaultSerUserId) {
        this.bindingForm.serUserId = this.defaultSerUserId;
      }
      if (this.defaultExternalUserId) {
        this.bindingForm.externalUserId = this.defaultExternalUserId;
      }
    },
  },
};
</script>

<style scoped>
.order-binding {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}

.binding-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.binding-header h3 {
  margin: 0 0 8px 0;
  color: #303133;
  font-size: 18px;
  font-weight: 500;
}

.binding-header p {
  margin: 0;
  color: #606266;
  font-size: 14px;
}

.el-form {
  max-width: 500px;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-input {
  width: 100%;
}

.el-button {
  margin-right: 10px;
}

/* 响应式布局 - 桌面端 */
@media (min-width: 768px) {
  .order-binding {
    padding: 20px;
  }

  .binding-header h3 {
    font-size: 18px;
  }

  .binding-header p {
    font-size: 14px;
  }

  .el-form {
    max-width: 500px;
  }

  .el-form-item__label {
    font-size: 14px;
  }

  .el-input__inner {
    font-size: 14px;
  }

  .el-button {
    font-size: 14px;
  }
}

/* 企业微信侧边栏适配 - 移动端 */
@media (max-width: 400px) {
  .order-binding {
    padding: 6px;
  }

  .binding-header h3 {
    font-size: 12px;
  }

  .binding-header p {
    font-size: 9px;
  }

  .el-form {
    max-width: 100%;
  }

  .el-form-item {
    margin-bottom: 12px;
  }

  .el-form-item__label {
    font-size: 9px;
    line-height: 1.2;
  }

  .el-input__inner {
    font-size: 10px;
    height: 28px;
    line-height: 28px;
  }

  .el-button {
    font-size: 9px;
    padding: 6px 12px;
  }

  .el-button--small {
    font-size: 9px;
    padding: 4px 8px;
  }
}

/* 中等屏幕适配 */
@media (min-width: 401px) and (max-width: 767px) {
  .order-binding {
    padding: 15px;
  }

  .binding-header h3 {
    font-size: 16px;
  }

  .binding-header p {
    font-size: 13px;
  }

  .el-form {
    max-width: 100%;
  }

  .el-form-item__label {
    font-size: 13px;
  }

  .el-input__inner {
    font-size: 13px;
  }

  .el-button {
    font-size: 13px;
  }
}
</style>